<template>
  <button
      class="btn btn-xs mr-5" :class="'btn-' + btnStyle"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      data-bs-trigger="hover"
      :title="title"
      @click="$emit('click', $event)"
  >
    <slot></slot>
  </button>
</template>

<script>
  export default {
    name: "s-button",
    props: [
      'title',
      'btnStyle' // primary, danger, ...
    ],
    watch: {
      title() {  // Hack to update the tooltip wording. stackoverflow.com/a/9875490
        setTimeout(_ => window.jQuery(this.$el)?.tooltip('fixTitle')?.tooltip(), 0)
      }
    },
    mounted() {
      window.jQuery(this.$el)?.tooltip()
    }
  }
</script>
